import React, { useEffect, useState } from "react";
import RestrictionsTable from "./table";
import useRequest from "../../../components/hooks/use-request";
import Pagination from "../../../components/pagination/pagination";

const Restriction = () => {
  const [data, setData] = useState<any[]>([]);
  const params = new URLSearchParams(new URL(window.location.href).search);
  const [currentPage, setCurrentPage] = useState(
    Number(params.get("page") || 1)
  );
  const [totalPages, setTotalPages] = useState<number>(1);
  const itemsPerPage = 10;

  const userToken = localStorage.getItem("token");

  const { makeRequest, loading } = useRequest(
    "/users/restriction/history",
    "GET",
    {
      Authorization: `Bearer ${userToken}`,
    }
  );

  const fetchData = async () => {
    const page = currentPage;
    const limit = itemsPerPage;
    const params: {
      search?: string;
      userType?: string;
      startDate?: string;
      endDate?: string;
      status?: string;
      limit: number;
      page: number;
    } = {
      limit,
      page,
    };

    // if (selectedStatus) {
    //   params.status = selectedStatus;
    // }
    // if (searchQuery) {
    //   params.search = searchQuery;
    // }
    // if (startDate) {
    //   params.startDate = startDate;
    // }
    // if (endDate) {
    //   params.endDate = endDate;
    // }

    const [response] = await makeRequest(undefined, params);
    setData(response?.data || []);
    setTotalPages(Math.ceil(response?.data?.totalPages));
  };

  useEffect(() => {
    fetchData();
  }, []);

  function handlePageChange(page: number) {
    setCurrentPage(page);
  }

  return (
    <>
      <RestrictionsTable
        data={data}
        selectedStatus={""}
        handleStatusChange={() => {}}
        loading={loading}
      />
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
};

export default Restriction;
